export default "__VITE_ASSET__0b041fea__"